import envConfig from "../config/envConfig";

export const DAY_MILLISECONDS: number = 86400000;
export const EXPECTED_WORK_TIME_FOR_DAY_BASE_30_MIN = 1800;
export const GOOGLE_AUTH = `${envConfig.API_URL}api/v1/auth/google`;
